import React from "react";
import BrandMark from "@/components/BrandMark";

const AuthShell = ({ title, subtitle, children }) => {
  return (
    <div className="min-h-screen w-full flex bg-slate-100">
      {/* Brand panel */}
      <div className="hidden lg:flex w-[42%] flex-col justify-between p-12 text-white relative overflow-hidden" style={{ background: "#002FA7" }}>
        <div className="relative z-10">
          <BrandMark height={40} className="shadow-lg" />
        </div>
        <div className="relative z-10">
          <h2 className="font-doc text-4xl font-bold leading-tight">Structured documents,<br />on brand, in seconds.</h2>
          <p className="text-blue-100 mt-4 text-sm max-w-sm leading-relaxed">
            Turn rough notes into polished SOPs, policies and work instructions — with automatic flowcharts and one-click PDF or Word export.
          </p>
        </div>
        <div className="text-[11px] text-blue-200 relative z-10">Confidential Internal Tool · Authorized Personnel Only</div>
        <div className="absolute -bottom-24 -right-24 w-96 h-96 rounded-full bg-white/5" />
        <div className="absolute -top-16 -left-16 w-72 h-72 rounded-full bg-white/5" />
      </div>

      {/* Form panel */}
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-[400px]">
          <div className="lg:hidden mb-8">
            <BrandMark height={30} />
          </div>
          <h1 className="font-heading font-black text-2xl text-slate-900">{title}</h1>
          {subtitle && <p className="text-sm text-slate-500 mt-1.5">{subtitle}</p>}
          <div className="mt-7">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default AuthShell;
